export default function Reducer(prevState, action){
    switch (action.type) {
        case "IS_LOADING":
            return {
                ...prevState,
                is_loading: true,
            };
        case "IS_LOADED": 
            return {
                ...prevState,
                is_loading: false,
                job_invoices: action.job_invoices,
                total_invoices: action.total_invoices,
                total_pages: action.total_pages,
            }; 
        case "UPDATE_CURRENT_PAGE":
            return {
                ...prevState,
                current_page: action.current_page
            } 
        case "SET_SERACH_TEXT":
            return {
                ...prevState,
                current_page: 1,
                serach_text: action.serach_text,
            }; 
        case "SET_SORT_CONFIG":
            return {
                ...prevState,
                sort_key: action.sort_key,
                sort_direction: action.sort_direction,
            }; 
        default:
            return prevState;
    }
}